import { trackInsight } from '@framework/appInsights';

const useSendStatelessInsight = () => {
    const sendInsight = (insightName: string, data?: { [key: string]: unknown }) => {
        return trackInsight(insightName, data);
    };

    return sendInsight;
};

export default useSendStatelessInsight;
